/* eslint-disable camelcase */
import moment from "moment";

import { coreAPIrequest, request, searchRequest } from "./request";

class QueryBuilder {
  constructor() {
    this.query = new URLSearchParams();
  }

  add(key, value) {
    if (value) {
      this.query.append(key, value);
    }
    return this;
  }

  build() {
    return this.query.toString();
  }
}

export const getEarningByMonthAndMango = (userId, currentDate) => {
  return request({
    url: `/admin/get-user-earnings/${userId}?currentMonth=${currentDate}`,
    method: "GET",
  });
};

export const getNoAccountUser = (page) => {
  return request({
    url: `/admin/get-no-account-user?page=${page}`,
    method: "GET",
  });
};

export const getNonTransferredPayments = (page, date, searchValue) => {
  return request({
    url: `/admin/get-non-transferred-payments?page=${page}&beforeDate=${date}&search=${searchValue}`,
    method: "GET",
  });
};

export const getAllUserList = (page, searchValue) => {
  const term = searchValue ? `&term=${searchValue}` : ``;
  return request({
    url: `/admin/get-all-user-list?page=${page}${term}`,
    method: "GET",
  });
};

export const getCreatorOrderList = (userId, page, date, radioValue) => {
  const orderType = radioValue !== "both" ? `&orderType=${radioValue}` : ``;
  return request({
    url: `admin/get-order-list/creator/${userId}?page=${page}&beforeDate=${date}${orderType}`,
    method: "GET",
  });
};

export const getCreatorMangoList = (userId, date) => {
  return request({
    url: `admin/get-mango-list/creator/${userId}?beforeDate=${date}`,
    method: "GET",
  });
};

export const getIncommingToPay = (date) => {
  return request({
    url: `/admin/get-incomming-to-pay?beforeDate=${date.toISOString()}`,
    method: "GET",
  });
};

export const getAllUser = async (page, query, filterUserType, options) => {
  const searchQuery = new URLSearchParams();
  if (query) searchQuery.append("term", query);
  if (page) searchQuery.append("page", page);
  if (filterUserType !== "all") searchQuery.append("userType", filterUserType);

  return searchRequest(`/admin/get-all-user?${searchQuery.toString()}`, {
    method: "GET",
    ...options,
  });
};

export const getPerDayEaring = (date, selectedRole) => {
  const selectedDate = date || new Date().toISOString();
  const startDay = moment(new Date(selectedDate)).startOf("day").toISOString();
  const endDay = moment(new Date(selectedDate)).endOf("day").toISOString();
  return request({
    url: `/admin/get-per-day-earing?date=${date}&userType=${selectedRole}&startDay=${startDay}&endDay=${endDay}`,
    method: "GET",
  });
};

export const userLogin = (data) => {
  return request({
    url: `/admin/login`,
    method: "post",
    data,
  });
};

export const getDateRangeEaring = (
  startDate,
  endDate,
  onlyEarning,
  page,
  searchBy,
  searchFieldText
) => {
  const searchQuery = searchBy
    ? `&searchBy=${searchBy}&term=${searchFieldText}`
    : "";
  return request({
    url: `/admin/get-date-range-earing?startDate=${startDate}&endDate=${endDate}&onlyEarning=${onlyEarning}&page=${page}${searchQuery}`,
    method: "GET",
  });
};

export const getDateRangeEarningV2 = (queryString) =>
  request({
    url: `/admin/v2/get-date-range-earning?${queryString}`,
    method: "GET",
  });

export const getDateRangeUserDetails = (
  startDate,
  endDate,
  onlyCount,
  userType,
  page,
  searchBy,
  searchFieldText,
  onlyWhitelabel
) => {
  const query = new URLSearchParams();
  if (page) {
    query.append("page", page);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (searchBy && searchFieldText) {
    query.append("searchBy", searchBy);
    query.append("term", searchFieldText);
  }
  if (userType) query.append("userType", userType);
  if (onlyCount) query.append("onlyCount", onlyCount);
  if (onlyWhitelabel) query.append("onlyWhitelabel", onlyWhitelabel);

  return request({
    url: `/admin/get-date-range-user-details?${query.toString()}`,
    method: "GET",
  });
};

export const getUserDetailsFromOrder = (startDate, endDate, userType) => {
  const userParams = userType ? `&userType=${userType}` : "";
  return request({
    url: `/admin/get-user-details-from-order?startDate=${startDate}&endDate=${endDate}${userParams}`,
    method: "GET",
  });
};

export const updateUserDetails = (data) => {
  return request({
    url: `/admin/update_user_details`,
    method: "post",
    data,
  });
};

export const getAllInfluencers = (term, page) => {
  const termString = term ? `&term=${term}` : "";
  return request({
    url: `/get-all-influencers?page=${page}${termString}`,
    method: "GET",
  });
};

export const getCreatorDetailsWithHiddenMangoes = (
  id,
  fetchSubscriberCount = false
) => {
  return request({
    url: `/get-creator-details/${id}?subscriber_count=${fetchSubscriberCount}&showhiddenmangoes=true`,
    method: "GET",
  });
};

export const sendPushNotifications = (data) => {
  return request({
    url: "/admin/v2/send-push-notification",
    method: "POST",
    data,
  });
};

export const uploadImage = (data) => {
  return request({
    url: `/admin/upload-image`,
    method: "POST",
    data,
  });
};

export const uploadFileStatic = (data) => {
  return request({
    url: `/admin/upload-file-static`,
    method: "POST",
    data,
  });
};

export const manualTransfer = (data) => {
  return request({
    url: `/admin/manual-transfer`,
    method: "POST",
    data,
  });
};

export const createCoupon = (data) => {
  return request({
    url: `/admin/create-coupon`,
    method: "POST",
    data,
  });
};

export const getCoupon = (data) => {
  return request({
    url: `/admin/get-coupons`,
    method: "POST",
    data,
  });
};

export const deactivateCoupon = (data) => {
  return request({
    url: "/admin/deactivate-coupon",
    method: "POST",
    data,
  });
};

export const getRequestedAccessCreators = (query) => {
  return request({
    url: `/admin/requested-access?search=${query}`,
    method: "GET",
  });
};

export const approveCreator = (userId) => {
  return request({
    url: `/admin/approve-creator?userId=${userId}`,
    method: "GET",
  });
};

export const editCoupon = (data) => {
  return request({
    url: `/admin/edit-coupon?coupon=${data.code}`,
    method: "POST",
    data,
  });
};

export const getCreatorsEarnings = (
  startDate,
  endDate,
  search,
  nature,
  type,
  whitelabelPlanType,
  csv,
  page,
  accountManager,
  isLifetime
) => {
  const query = new URLSearchParams();
  if (page) {
    query.append("page", page);
  }
  if (search) query.append("search", search);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (csv) query.append("csv", true);
  if (type && type !== "all") query.append("creatorType", type);
  if (nature) {
    nature.forEach((elem) => {
      query.append("nature[]", elem);
    });
  }
  if (whitelabelPlanType && whitelabelPlanType !== "all") {
    query.append("whitelabelPlanType", whitelabelPlanType);
  }
  if (accountManager) query.append("accountManager", accountManager);
  if (isLifetime) query.append("isLifetime", isLifetime);

  return request({
    url: `/admin/creator-earnings?${query.toString()}`,
    method: "GET",
  });
};

export const getCreatorEarningsUpdateStatus = () => {
  return request({
    url: `/admin/creator-earnings-update/status`,
    method: "GET",
  });
};

export const triggerCreatorEarningsUpdate = () => {
  return request({
    url: `/admin/creator-earnings-update/trigger`,
    method: "POST",
  });
};

export const getCreatorMangoEarnings = (creatorId, startDate, endDate) => {
  return request({
    url: `/admin/creator-mango-earnings?creatorId=${creatorId}&startDate=${startDate}&endDate=${endDate}`,
    method: "GET",
  });
};

export const changeCreatorNature = (data) => {
  return request({
    url: `/admin/change-creator-nature`,
    method: "POST",
    data,
  });
};

export const getCohortSheet = () => {
  return request({
    url: `/admin/all-creator-earnings-with-month?csv=true`,
    method: "GET",
  });
};

export const getCreatorWalletStatement = (startDate, endDate, currency) => {
  return request({
    url: `/admin/creator-wallet-statement?startDate=${startDate}&endDate=${endDate}&currency=${currency}`,
    method: "GET",
  });
};

export const getRestrictionStatus = () => {
  return request({
    url: `/admin/get-restriction-status`,
    method: "GET",
  });
};

export const getActiveSubscribers = (creator, mango) => {
  return request({
    url: `/admin/get-active-subscribers?creator=${creator}&mango=${mango}`,
    method: "GET",
  });
};

export const sendCertificateMails = (data, sendTest) => {
  return request({
    url: `/admin/send-certificate-mails?sendTest=${sendTest}`,
    method: "POST",
    data,
  });
};

export const getActivePaymentTerm = (creator) => {
  return request({
    url: `/admin/get-active-term?creator=${creator}`,
    method: "GET",
  });
};

export const createPaymentTerm = (data) => {
  return request({
    url: `/admin/create-payment-term`,
    method: "POST",
    data,
  });
};

export const editPaymentTerm = (id, data) => {
  return request({
    url: `/admin/edit-payment-term?id=${id}`,
    method: "POST",
    data,
  });
};

export const getUpcomingPayouts = (
  endDate,
  page,
  limit,
  search,
  paymentTermId,
  customLastDate
) => {
  return request({
    url: `/admin/get-upcoming-payouts?endDate=${endDate}&page=${page}&limit=${limit}${
      search !== "" ? `&search=${search}` : ""
    }${paymentTermId ? `&paymentTermId=${paymentTermId}` : ""}${
      customLastDate ? `&customLastDate=${customLastDate}` : ""
    }`,
    method: "GET",
  });
};

export const createPayout = (data) => {
  return request({
    url: `/admin/create-payout`,
    method: "POST",
    data,
  });
};

export const getPayoutHistory = (creator, startDate, endDate, page, limit) => {
  return request({
    url: `/admin/get-payout-history?creator=${creator}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`,
    method: "GET",
  });
};

export const getUpcomingPayoutOrders = (
  paymentTerm,
  endDate,
  page,
  limit,
  search
) => {
  return request({
    url: `/admin/get-upcoming-payout-orders?paymentTerm=${paymentTerm}&endDate=${endDate}&page=${page}&limit=${limit}${
      search !== "" ? `&search=${search}` : ""
    }`,
    method: "GET",
  });
};

export const getCouponsV2 = (
  startDate,
  endDate,
  search,
  creatorId,
  showExpired,
  showMoengage,
  page,
  limit
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (search) query.append("search", search);
  if (creatorId) query.append("creatorId", creatorId);
  if (showExpired) query.append("showExpired", true);
  if (showMoengage) query.append("showMoengage", true);
  return request({
    method: "GET",
    url: `/admin/v2/get-coupons?${query.toString()}`,
  });
};

export const getAllAdminUsers = (search) => {
  const query = new URLSearchParams();
  if (search) query.append("search", search);
  return request({
    method: "GET",
    url: `/admin/all-admin-users?${query.toString()}`,
  });
};

export const updateAdminUser = (user, data) => {
  return request({
    method: "POST",
    url: `/admin/update-admin-user?user=${user}`,
    data,
  });
};

export const signup = (data) => {
  return request({
    method: "POST",
    url: `/admin/signup`,
    data,
  });
};

export const sendDashboardMails = (data) => {
  return request({
    method: "POST",
    url: `/admin/send-dashboard-mails`,
    data,
  });
};

export const getRecipientsCount = (data) => {
  return request({
    method: "POST",
    url: `/admin/get-recipients-count`,
    data,
  });
};

export const getDashboardMails = (startDate, endDate, search, page, limit) => {
  const query = new URLSearchParams();

  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (search) query.append("search", search);
  return request({
    method: "GET",
    url: `/admin/get-dashboard-mails?${query.toString()}`,
  });
};

export const getMailsByCampaign = (
  campaignId,
  deliveryStatus,
  opened,
  search,
  page,
  limit
) => {
  return request({
    method: "GET",
    url: `/admin/get-mails-by-campaign?campaignId=${campaignId}${
      deliveryStatus ? `&deliveryStatus=${deliveryStatus}` : ""
    }${opened ? `&opened=${opened}` : ""}${
      search ? `&search=${search}` : ""
    }&page=${page}&limit=${limit}`,
  });
};

export const getCampaigns = (search, page, limit) => {
  return request({
    method: "GET",
    url: `/admin/get-mail-campaigns?search=${search}&page=${page}&limit=${limit}`,
  });
};

export const getWithdrawalRequests = (
  startDate,
  endDate,
  approvalStatus,
  search,
  transferMode,
  automaticEligible,
  payoutStatus,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (search) query.append("search", search);
  if (approvalStatus) query.append("approvalStatur", approvalStatus);
  if (csv) query.append("csv", true);
  if (transferMode) query.append("transferMode", transferMode);
  if (automaticEligible) query.append("automaticEligible", automaticEligible);
  if (payoutStatus) query.append("payoutStatus", payoutStatus);
  return request({
    method: "GET",
    url: `/admin/get-withdrawal-requests?${query.toString()}`,
  });
};

export const getWalletWithdrawalRequests = (
  startDate,
  endDate,
  approvalStatus,
  search,
  transferMode,
  automaticEligible,
  payoutStatus,
  whitelabelPlanType,
  userTier,
  creatorCountryType,
  page,
  limit,
  csv,
  currency, // 'USD' lists FIRC foreign-compartment withdrawals (TMG-2249)
  isFIRCWithdrawal // when true, restricts results to FIRC-marked withdrawals only (TMG-2249)
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (approvalStatus) query.append("approvalStatus", approvalStatus);
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (transferMode) query.append("transferMode", transferMode);
  if (automaticEligible) query.append("automaticEligible", automaticEligible);
  if (payoutStatus) query.append("payoutStatus", payoutStatus);
  if (whitelabelPlanType)
    query.append("whitelabelPlanType", whitelabelPlanType);
  if (userTier) query.append("userTier", userTier);
  if (creatorCountryType)
    query.append("creatorCountryType", creatorCountryType);
  if (currency) query.append("currency", currency);
  if (isFIRCWithdrawal) query.append("isFIRCWithdrawal", true);
  return request({
    method: "GET",
    url: `/admin/get-wallet-withdrawal-requests?${query.toString()}`,
  });
};

export const handleWithdrawalRequest = (data) => {
  return request({
    method: "POST",
    url: `/admin/handle-withdrawal-request`,
    data,
  });
};

export const handleWalletWithdrawalRequest = (data) => {
  return request({
    method: "POST",
    url: `/admin/handle-wallet-withdrawal-request`,
    data,
  });
};

export const getOrdersOfWithdrawal = (
  withdrawalId,
  search,
  statusFilter,
  page,
  limit
) => {
  return request({
    method: "GET",
    url: `/admin/get-orders-of-withdrawal?withdrawalId=${withdrawalId}${
      search ? `&search=${search}` : ""
    }&page=${page}&limit=${limit}${
      statusFilter ? `&statusFilter=${statusFilter}` : ""
    }`,
  });
};

export const createRefund = (data) => {
  return request({
    method: "POST",
    url: `/admin/create-refund`,
    data,
  });
};

export const downloadWithdrawalBreakdown = (withdrawalId, creatorId) => {
  return request({
    method: "GET",
    url: `/admin/withdrawal-breakdown?withdrawalId=${withdrawalId}&creator=${creatorId}`,
  });
};

export const getUpcomingMangos = (startDate, endDate, search, page, limit) => {
  return request({
    method: "GET",
    url: `/admin/upcoming-mangos?startDate=${startDate}&endDate=${endDate}${
      search ? `&search=${search}` : ""
    }&page=${page}&limit=${limit}`,
  });
};

export const getCreatorFunnelUTMS = (search, page, limit) => {
  return request({
    method: "GET",
    url: `/admin/creator-utm-campaigns?search=${search}&page=${page}&limit=${limit}`,
  });
};

export const getFunnelCounts = (utm_campaign, startDate, endDate) => {
  return request({
    method: "GET",
    url: `/admin/creator-funnel-counts?utm_campaign=${utm_campaign}&startDate=${startDate}&endDate=${endDate}`,
  });
};

export const getFunnelStageCreators = (
  utm_campaign,
  startDate,
  endDate,
  funnelStage,
  page,
  limit,
  csv
) => {
  return request({
    method: "GET",
    url: `/admin/funnel-stage-creators?utm_campaign=${utm_campaign}&startDate=${startDate}&endDate=${endDate}&funnelStage=${funnelStage}&page=${page}&limit=${limit}${
      csv ? "&csv=true" : ""
    }`,
  });
};

export const getCategories = () => {
  return request({
    method: "GET",
    url: `/categories`,
  });
};

export const getPendingBytescareRequests = () => {
  return request({
    method: "GET",
    url: `/admin/bytescare-pending-requests`,
  });
};

export const approveRequestToBytescare = (data) => {
  return request({
    method: "POST",
    url: `/admin/approve-bytescare-request`,
    data,
  });
};

export const getManualRefundRequests = (page, limit) => {
  return request({
    method: "GET",
    url: `/admin/get-refund-requests?page=${page}&limit=${limit}`,
  });
};

export const migrateSubs = (creatorId, mangoId, coupon, subs) => {
  return request({
    method: "POST",
    url: `/admin/migrate-users?creatorId=${creatorId}&mangoId=${mangoId}&coupon=${coupon}`,
    data: {
      subs,
    },
  });
};

export const checkAutomaticWithdrawalStatus = (withdrawalId) => {
  return request({
    method: "GET",
    url: `/admin/withdrawal-status?withdrawalId=${withdrawalId}`,
  });
};

export const getWhatsappUsers = (
  status,
  subscriptionStatus,
  search,
  expiryDateStart,
  expiryDateEnd,
  autopayStatus,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (status) query.append("status", status);
  if (subscriptionStatus)
    query.append("subscriptionStatus", subscriptionStatus);
  if (csv) query.append("csv", true);
  if (expiryDateStart) query.append("expiryDateStart", expiryDateStart);
  if (expiryDateEnd) query.append("expiryDateEnd", expiryDateEnd);
  if (autopayStatus) query.append("autopayStatus", autopayStatus);

  return request({
    method: "GET",
    url: `/admin/whatsapp-users?${query.toString()}`,
  });
};

export const updateWhatsappConfig = (data) => {
  return request({
    method: "POST",
    url: `/admin/whatsapp-config`,
    data,
  });
};

export const updateWhatsappTierExpiry = (data) => {
  return request({
    method: "POST",
    url: `/admin/whatsapp-expiry`,
    data,
  });
};

export const getCommissionTaxReport = (
  startDate,
  endDate,
  search,
  creatorCountryType,
  currency,
  page,
  limit,
  csv
) => {
  const queryBuild = new QueryBuilder();
  queryBuild.add("startDate", startDate);
  queryBuild.add("endDate", endDate);
  queryBuild.add("search", search);
  queryBuild.add("creatorCountryType", creatorCountryType);
  queryBuild.add("currency", currency);
  queryBuild.add("page", page);
  queryBuild.add("limit", limit);
  queryBuild.add("csv", csv);
  return request({
    method: "GET",
    url: `/admin/get-commission-convenience-tax-report?${queryBuild.build()}`,
  });
};

export const getWhatsappSubscriptionTaxReport = (
  startDate,
  endDate,
  search,
  creatorCountryType,
  page,
  limit,
  csv
) => {
  const queryBuild = new QueryBuilder();
  queryBuild.add("startDate", startDate);
  queryBuild.add("endDate", endDate);
  queryBuild.add("search", search);
  queryBuild.add("creatorCountryType", creatorCountryType);
  queryBuild.add("page", page);
  queryBuild.add("limit", limit);
  queryBuild.add("csv", csv);
  return request({
    method: "GET",
    url: `/admin/get-whatsapp-subs-tax-report?${queryBuild.build()}`,
  });
};

export const getMangoCreditsTaxReport = (
  startDate,
  endDate,
  search,
  creatorCountryType,
  page,
  limit,
  csv
) => {
  const queryBuild = new QueryBuilder();
  queryBuild.add("startDate", startDate);
  queryBuild.add("endDate", endDate);
  queryBuild.add("search", search);
  queryBuild.add("creatorCountryType", creatorCountryType);
  queryBuild.add("page", page);
  queryBuild.add("limit", limit);
  queryBuild.add("csv", csv);
  return request({
    method: "GET",
    url: `/admin/get-mango-credits-tax-report?${queryBuild.build()}`,
  });
};

export const getTaxReportForCreator = (month, creatorId) => {
  return request({
    url: `/admin/tax-report?month=${month}&creatorId=${creatorId}`,
    method: "GET",
    responseType: "blob",
  });
};

export const getAffiliatesEarnings = (
  startDate,
  endDate,
  search,
  creator,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (creator) query.append("creator", creator);
  return request({
    method: "GET",
    url: `/admin/affiliate-earnings?${query.toString()}`,
  });
};

export const getOrdersOfAffiliate = (
  affiliateId,
  startDate,
  endDate,
  search,
  page,
  limit,
  csv
) => {
  return request({
    method: "GET",
    url: `/admin/get-orders-of-affiliate?affiliate=${affiliateId}&startDate=${startDate}&endDate=${endDate}${
      page && limit ? `&page=${page}&limit=${limit}` : ""
    }${search ? `&search=${search}` : ""}${csv ? "&csv=true" : ""}`,
  });
};

export const getWithdrawalOtp = (withdrawalId) => {
  return request({
    method: "GET",
    url: `/admin/get-withdrawal-otp?withdrawalId=${withdrawalId}`,
  });
};

export const getWalletWithdrawalOtp = (withdrawalId) => {
  return request({
    method: "GET",
    url: `/admin/get-wallet-withdrawal-otp?withdrawalId=${withdrawalId}`,
  });
};

export const getBulkWithdrawalOtp = (data) => {
  return request({
    method: "POST",
    url: `/admin/get-bulk-withdrawal-otp`,
    data,
  });
};

export const getBulkWalletWithdrawalOtp = (data) => {
  return request({
    method: "POST",
    url: `/admin/get-bulk-wallet-withdrawal-otp`,
    data,
  });
};

export const handleBulkWithdrawal = (data) => {
  return request({
    method: "POST",
    url: `/admin/handle-bulk-withdrawal`,
    data,
  });
};

export const handleBulkWalletWithdrawal = (data) => {
  return request({
    method: "POST",
    url: `/admin/handle-bulk-wallet-withdrawal`,
    data,
  });
};

export const getTagmangoCreatorsData = (
  {
    search,
    startDate,
    endDate,
    earningGt,
    earningLt,
    mangoCountGt,
    mangoCountLt,
    page,
    limit,
    csv,
  },
  options
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (earningGt) query.append("earningGt", earningGt);
  if (earningLt) query.append("earningLt", earningLt);
  if (mangoCountGt) query.append("mangoCountGt", mangoCountGt);
  if (mangoCountLt) query.append("mangoCountLt", mangoCountLt);
  return searchRequest(`/admin/tagmango-creators-list?${query.toString()}`, {
    method: "GET",
    ...options,
  });
};

export const getWhitelabelCreatorsData = (
  {
    search,
    whitelabelPlanType,
    tier,
    domainActivationStatus,
    startDate,
    endDate,
    earningGt,
    earningLt,
    mangoCountGt,
    mangoCountLt,
    tierExpiryDateGt,
    tierExpiryDateLt,
    tierExpired,
    platformSuspensionStatus,
    tierAutopayStatus,
    accountManager,
    page,
    limit,
    csv,
  },
  options
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (whitelabelPlanType)
    query.append("whitelabelPlanType", whitelabelPlanType);
  if (tier) query.append("tier", tier);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (earningGt) query.append("earningGt", earningGt);
  if (earningLt) query.append("earningLt", earningLt);
  if (mangoCountGt) query.append("mangoCountGt", mangoCountGt);
  if (mangoCountLt) query.append("mangoCountLt", mangoCountLt);
  if (domainActivationStatus)
    query.append("domainActivationStatus", domainActivationStatus);
  if (tierExpiryDateGt)
    query.append("subscriptionExpiryDateStart", tierExpiryDateGt);
  if (tierExpiryDateLt)
    query.append("subscriptionExpiryDateEnd", tierExpiryDateLt);
  if (tierExpired) query.append("tierExpired", tierExpired);
  if (platformSuspensionStatus)
    query.append("platformSuspensionStatus", platformSuspensionStatus);
  if (tierAutopayStatus) query.append("tierAutopayStatus", tierAutopayStatus);
  if (accountManager) query.append("accountManager", accountManager);
  return searchRequest(`/admin/whitelabel-creators-list?${query.toString()}`, {
    method: "GET",
    ...options,
  });
};

export const getCreatorDetails = (creatorId) => {
  return request({
    method: "GET",
    url: `/admin/get-creator-details?userId=${creatorId}`,
  });
};

// Enables/disables a mango as the creator's signup service (free mango).
// Only one signup service is allowed per creator — the backend rejects a second.
export const toggleMangoSignupService = (mangoId, enabled) => {
  return coreAPIrequest({
    method: "PUT",
    url: `/admin/mango/${mangoId}/signup-service`,
    data: { enabled },
  });
};

export const upgradePlan = (data) => {
  return request({
    method: "POST",
    url: `/admin/upgrade-wl-plan`,
    data,
  });
};

export const upgradeTier = (data) => {
  return request({
    method: "POST",
    url: `/admin/upgrade-wl-tier`,
    data,
  });
};

export const disableWhatsappConfig = (data) => {
  return request({
    method: "POST",
    url: `/admin/disable-whatsapp-config`,
    data,
  });
};

export const enableWhatsappConfig = (data) => {
  return request({
    method: "POST",
    url: `/admin/enable-whatsapp-config`,
    data,
  });
};

export const suspendPlatform = (data) => {
  return request({
    method: "POST",
    url: `/admin/suspend-platform`,
    data,
  });
};

export const getLedgerOfWallet = (
  user,
  startDate,
  endDate,
  transactionType,
  page,
  limit,
  csv
) => {
  return request({
    method: "GET",
    url: `/admin/get-ledger-of-wallet?user=${user}&startDate=${startDate}&endDate=${endDate}&transactionType=${transactionType}&page=${page}&limit=${limit}${
      csv ? "&csv=true" : ""
    }`,
  });
};

export const getOrdersOfWallet = (
  user,
  startDate,
  endDate,
  page,
  limit,
  csv
) => {
  return request({
    method: "GET",
    url: `/admin/get-orders-for-wallet?user=${user}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}${
      csv ? "&csv=true" : ""
    }`,
  });
};

export const getTotalWithdrawnOldToDate = (user) => {
  return request({
    method: "GET",
    url: `/admin/total-withdrawn-to-date?user=${user}`,
  });
};

export const getHomeWidgets = (startDate, endDate, onlyWhitelabel) => {
  return request({
    method: "GET",
    url: `/admin/home-widgets?startDate=${startDate}&endDate=${endDate}${
      onlyWhitelabel ? "&onlyWhitelabel=true" : ""
    }`,
  });
};

export const updateWLExpiry = (data) => {
  return request({
    method: "POST",
    url: `/admin/update-wl-expiry`,
    data,
  });
};

export const getRefernEarnRequests = (
  accessStatus,
  search,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (accessStatus) query.append("accessStatus", accessStatus);
  return request({
    method: "GET",
    url: `/admin/refern-earn-requests?${query.toString()}`,
  });
};

export const updateRefernEarnRequest = (data) => {
  return request({
    method: "POST",
    url: `/admin/update-refern-earn-request`,
    data,
  });
};

export const getRefernEarnEarnings = (
  startDate,
  endDate,
  search,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (csv) query.append("csv", true);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  return request({
    method: "GET",
    url: `/admin/refern-earn-earnings?${query.toString()}`,
  });
};

export const getRefernEarnProductSales = (user, startDate, endDate) => {
  return request({
    method: "GET",
    url: `/admin/refern-product-sales?user=${user}${
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : ""
    }`,
  });
};

export const getRefernEarnSalesOfProduct = (
  product,
  startDate,
  endDate,
  search,
  page,
  limit,
  csv
) => {
  return request({
    method: "GET",
    url: `/admin/refern-product-sales-data?product=${product}${
      startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : ""
    }${search ? `&search=${search}` : ""}&page=${page}&limit=${limit}${
      csv ? "&csv=true" : ""
    }`,
  });
};

export const createRefernEarnPayout = (data) => {
  return request({
    method: "POST",
    url: `/admin/create-refern-earn-payout`,
    data,
  });
};

export const getRefernEarnPayouts = (user) => {
  return request({
    method: "GET",
    url: `/admin/refern-earn-payouts?user=${user}`,
  });
};

export const createRefernEarnProduct = (data) => {
  return request({
    method: "POST",
    url: `/admin/create-refern-earn-product`,
    data,
  });
};

export const editRefernEarnProduct = (product, data) => {
  return request({
    method: "POST",
    url: `/admin/update-refern-earn-product?product=${product}`,
    data,
  });
};

export const tagUserWithRefernEarnParent = (data) => {
  return request({
    method: "PATCH",
    url: `/admin/refern-earn/signup-tag`,
    data,
  });
};

export const cancelTierSubscription = (data) => {
  return request({
    method: "POST",
    url: `/admin/cancel-tier-subscription`,
    data,
  });
};

export const cancelWhatsappSubscription = (data) => {
  return request({
    method: "POST",
    url: `/admin/cancel-whatsapp-subscription`,
    data,
  });
};

export const getWhatsappOrdersOfUser = (userId, page, limit) => {
  return request({
    method: "GET",
    url: `/admin/whatsapp-orders-of-user?userId=${userId}&page=${page}&limit=${limit}`,
  });
};

export const getTierOrders = (
  startDate,
  endDate,
  search,
  tier,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (tier && tier?.length) {
    tier.forEach((each) => {
      query.append("tier[]", each);
    });
  }
  if (csv) query.append("csv", true);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  return request({
    method: "GET",
    url: `/admin/tier-orders?${query.toString()}`,
  });
};

export const getRefernEarnSignups = (user, page, limit, csv) => {
  return request({
    method: "GET",
    url: `/admin/refern-earn-signups?user=${user}${
      page && limit ? `&page=${page}&limit=${limit}` : ""
    }${csv ? "&csv=true" : ""}`,
  });
};

export const getOnboardingStats = (startDate, endDate, search) => {
  const query = new URLSearchParams();
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (search) query.append("search", search);
  return request({
    method: "GET",
    url: `/admin/get-onboarding-stats?${query}`,
  });
};

export const getOnboardingData = (
  search,
  startDate,
  endDate,
  page,
  limit,
  csv
) => {
  const query = new URLSearchParams();
  if (page && limit) {
    query.append("page", page);
    query.append("limit", limit);
  }
  if (search) query.append("search", search);
  if (startDate && endDate) {
    query.append("startDate", startDate);
    query.append("endDate", endDate);
  }
  if (csv) query.append("csv", true);
  return request({
    method: "GET",
    url: `/admin/get-onboarding-data?${query.toString()}`,
  });
};

// Banner API starts //

export const getBanners = () => {
  return request({
    method: "GET",
    url: `/admin/banners`,
  });
};

/**
 * @deprecated Since TMG-1511. Use `createPlatformBanner` (below) which targets
 * the new `POST /api/v1/admin/platform-banners` endpoint with full
 * platform/setup/tier support.
 */
export const createBanners = (data) => {
  return request({
    method: "POST",
    url: `/admin/banners`,
    data,
  });
};

/**
 * @deprecated Since TMG-1511. Use `updatePlatformBanner` (below) which targets
 * the new `PUT /api/v1/admin/platform-banners/:id` endpoint.
 */
export const updateBanners = (data, id) => {
  return request({
    method: "PATCH",
    url: `/admin/banners/${id}`,
    data,
  });
};

// Platform Banners (revamp) — see TMG-1511
// List uses the existing `getBanners()` above (legacy /admin/banners).
// Create / Update use the new core-api endpoints via `coreAPIrequest`.
export const createPlatformBanner = (data) => {
  return coreAPIrequest({
    method: "POST",
    url: `/admin/platform-banners`,
    data,
  });
};

export const updatePlatformBanner = (data, id) => {
  return coreAPIrequest({
    method: "PUT",
    url: `/admin/platform-banners/${id}`,
    data,
  });
};

export const getCreatorPayables = (
  startDate,
  endDate,
  search,
  whitelabelPlanType,
  userTier,
  creatorCountryType,
  page,
  limit,
  csv
) => {
  const query = new QueryBuilder()
    .add("startDate", startDate)
    .add("endDate", endDate)
    .add("search", search)
    .add("whitelabelPlanType", whitelabelPlanType)
    .add("userTier", userTier)
    .add("creatorCountryType", creatorCountryType)
    .add("page", page)
    .add("limit", limit)
    .add("csv", csv);

  return request({
    method: "GET",
    url: `/admin/creator-payables?${query.build()}`,
  });
};

export const bulkCreateManualWalletDebit = (data) => {
  return request({
    method: "POST",
    url: `/admin/bulk-create-manual-wallet-debit`,
    data,
  });
};

// Banner API ends //

export const getLandingPagesTemplates = (query) => {
  console.log(query);
  return request({
    method: "GET",
    url: `/admin/landing-pages-templates${query}`,
  });
};

export const createLandingPageTemplate = (data) => {
  return request({
    method: "POST",
    url: `/admin/landing-page-template`,
    data,
  });
};

export const editLandingPageTemplate = (data) => {
  return request({
    method: "PATCH",
    url: `/admin/landing-page-template`,
    data,
  });
};

export const deleteLandingPageTemplate = (templateId) => {
  return request({
    method: "DELETE",
    url: `/admin/landing-page-template/${templateId}`,
  });
};

export const reorderLandingPageTemplate = (data) => {
  return request({
    method: "PATCH",
    url: `/admin/landing-page-template/reorder`,
    data,
  });
};

export const getRefunds = (startDate, endDate, search, page, limit, csv) => {
  const query = new QueryBuilder()
    .add("startDate", startDate)
    .add("endDate", endDate)
    .add("search", search)
    .add("page", page)
    .add("limit", limit)
    .add("csv", csv);
  return request({
    method: "GET",
    url: `/admin/refunds?${query.build()}`,
  });
};

// new partner dashboard apis

export const getRefernEarnProducts = ({
  search,
  status,
  limit,
  sort,
  sortOrder,
  user,
}) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }
  if (status) {
    params.append("status", status);
  }
  if (limit) {
    params.append("limit", limit);
  }
  if (sort) {
    params.append("sort", sort);
  }
  if (sortOrder) {
    params.append("sortOrder", sortOrder);
  }
  if (user) {
    params.append("user", user);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/products?${params.toString()}`,
  });
};

export const createRefernEarnProductNew = (values) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/products`,
    data: values,
  });
};

export const editRefernEarnProductNew = (productId, values) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/products/${productId}`,
    data: values,
  });
};

export const reorderRefernEarnProduct = (values) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/products/reorder`,
    data: values,
  });
};

export const getRefernEarnPartners = (
  {
    search,
    startDate,
    endDate,
    minProductValue,
    maxProductValue,
    minEarnings,
    maxEarnings,
    minPayout,
    maxPayout,
    minPendingCommission,
    maxPendingCommission,
    superPartner,
    pageSize,
    page,
  },
  csv
) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (startDate) {
    params.append("startDate", startDate.toISOString());
  }
  if (endDate) {
    params.append("endDate", endDate.toISOString());
  }
  if (minProductValue) {
    params.append("minProductValue", minProductValue);
  }
  if (maxProductValue) {
    params.append("maxProductValue", maxProductValue);
  }
  if (minEarnings) {
    params.append("minEarnings", minEarnings);
  }
  if (maxEarnings) {
    params.append("maxEarnings", maxEarnings);
  }
  if (minPayout) {
    params.append("minPayout", minPayout);
  }
  if (maxPayout) {
    params.append("maxPayout", maxPayout);
  }
  if (minPendingCommission) {
    params.append("minPendingCommission", minPendingCommission);
  }
  if (maxPendingCommission) {
    params.append("maxPendingCommission", maxPendingCommission);
  }
  if (superPartner && superPartner !== "all") {
    params.append("superPartner", superPartner);
  }
  if (pageSize) {
    params.append("pageSize", pageSize);
  }
  if (page) {
    params.append("page", page);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/partners${
      csv ? "/csv" : ""
    }?${params.toString()}`,
  });
};

export const getRefernEarnNonEarningPartners = (
  { search, startDate, endDate, superPartner, pageSize, page },
  csv
) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (startDate) {
    params.append("startDate", startDate.toISOString());
  }
  if (endDate) {
    params.append("endDate", endDate.toISOString());
  }
  if (superPartner && superPartner !== "all") {
    params.append("superPartner", superPartner);
  }
  if (pageSize) {
    params.append("limit", pageSize);
  }
  if (page) {
    params.append("page", page);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/partners/without-earnings${
      csv ? "/csv" : ""
    }?${params.toString()}`,
  });
};

export const getRefernEarnPayoutsNew = (
  {
    search,
    commissionPeriodStartDate,
    commissionPeriodEndDate,
    releaseStartDate,
    releaseEndDate,
    transactionType,
    pageSize,
    page,
  },
  csv = false
) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (commissionPeriodStartDate) {
    params.append(
      "commissionPeriodStartDate",
      commissionPeriodStartDate.toISOString()
    );
  }
  if (commissionPeriodEndDate) {
    params.append(
      "commissionPeriodEndDate",
      commissionPeriodEndDate.toISOString()
    );
  }
  if (releaseStartDate) {
    params.append("releaseStartDate", releaseStartDate.toISOString());
  }
  if (releaseEndDate) {
    params.append("releaseEndDate", releaseEndDate.toISOString());
  }
  if (transactionType) {
    params.append("transactionType", transactionType);
  }
  if (pageSize) {
    params.append("pageSize", pageSize);
  }
  if (page) {
    params.append("page", page);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/partners/payouts${
      csv ? "/csv" : ""
    }?${params.toString()}`,
  });
};

export const getRefernEarnOrders = (
  {
    search,
    statuses,
    tiers,
    platformSetups,
    startDate,
    endDate,
    type,
    pageSize,
    page,
  },
  csv = false
) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (statuses) {
    // statuses is an array
    statuses.forEach((status) => {
      params.append("statuses", status);
    });
  }
  if (tiers) {
    // tiers is an array
    tiers.forEach((tier) => {
      params.append("tiers", tier);
    });
  }
  if (platformSetups) {
    // platformSetups is an array
    platformSetups.forEach((platformSetup) => {
      params.append("platformSetups", platformSetup);
    });
  }
  if (startDate) {
    params.append("startDate", startDate.toISOString());
  }
  if (endDate) {
    params.append("endDate", endDate.toISOString());
  }
  if (type) {
    params.append("type", type);
  }
  if (pageSize) {
    params.append("pageSize", pageSize);
  }
  if (page) {
    params.append("page", page);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/tier-orders${csv ? "/csv" : ""}?${params.toString()}`,
  });
};

export const refundTierOrder = (id, data) =>
  request({
    method: "POST",
    url: `/api/v1/admin/tier-orders/${id}/refund`,
    data,
  });

export const getAdminCreatorById = (id) =>
  request({
    method: "GET",
    url: `/api/v1/admin/creators/${id}`,
  });

export const getRefernEarnPartnerSalesAnalytics = (productId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/products/${productId}/sales/analytics`,
  });
};

export const createRefernEarnPayoutToPartner = (values, partnerId) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/partners/${partnerId}/payout`,
    data: values,
  });
};

export const getRefernEarnPartnerSales = (
  { search, startDate, endDate, status, pageSize, page, productId },
  csv = false
) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }
  if (startDate) {
    params.append("startDate", startDate.toISOString());
  }
  if (endDate) {
    params.append("endDate", endDate.toISOString());
  }
  if (status) {
    params.append("type", status);
  }
  if (pageSize) {
    params.append("pageSize", pageSize);
  }
  if (page) {
    params.append("page", page);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/products/${productId}/sales${
      csv ? "/csv" : ""
    }?${params.toString()}`,
  });
};

export const getUserDetailsFromId = (userId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/creators/${userId}`,
  });
};

export const getUsersWithRefernEarnEnabled = ({ search, page, pageSize }) => {
  const params = new URLSearchParams();

  if (search) {
    params.append("search", search);
  }

  if (page) {
    params.append("page", page);
  }

  if (pageSize) {
    params.append("pageSize", pageSize);
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/refernearn/users/minimal?${params.toString()}`,
  });
};

export const createManagePlanPurchase = (values, userId) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/creators/${userId}/purchase`,
    data: {
      ...values,
      ...(values.tier === "tier4" && {
        // Note: Naveen's idea (ask him for more details)
        // also ask kanishk for more more details
        tmCommission: 0,
        stripeCommission: 5,
      }),
    },
  });
};

export const createManagePlanRefund = (values, userId) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/creators/${userId}/refund`,
    data: {
      ...values,
      ...(values.tier === "tier4" && {
        // Note: Naveen's idea (ask him for more details)
        // also ask kanishk for more more details
        tmCommission: 0,
        stripeCommission: 5,
      }),
    },
  });
};

export const suspendPartner = (partnerId) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/partners/${partnerId}/suspend`,
  });
};

export const unSuspendPartner = (partnerId) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/partners/${partnerId}/unsuspend`,
  });
};

export const updatePartnerSuperPartnerStatus = (partnerId, isSuperPartner) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/partners/${partnerId}/super-partner`,
    data: { isSuperPartner },
  });
};

// Revenue Share APIs
export const updatePartnerRevenueShare = (partnerId, revenueShare) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/partners/${partnerId}/revenue-share`,
    data: { revenueShare },
  });
};

export const validateBulkRevenueShare = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/partners/revenue-share/bulk/validate`,
    data,
  });
};

export const createBulkRevenueShare = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/partners/revenue-share/bulk`,
    data,
  });
};

export const createRefernEarnProductMigration = (values) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/products/migrations`,
    data: values,
  });
};

export const createManualWalletDebit = (data) => {
  return request({
    url: `/admin/create-manual-wallet-debit`,
    method: "POST",
    data,
  });
};

export const getMangoCreditTransactions = (
  startDate,
  endDate,
  search,
  transactionType,
  status,
  page,
  limit,
  csv = false,
  country
) => {
  const query = new URLSearchParams();

  if (startDate && endDate) {
    query.append("startDate", new Date(startDate).toISOString());
    query.append("endDate", new Date(endDate).toISOString());
  }

  if (search) query.append("search", search);
  if (transactionType) query.append("transactionType", transactionType);
  if (status) query.append("status", status);
  if (page) query.append("page", page);
  if (limit) query.append("limit", limit);
  if (country) query.append("country", country);

  if (!csv) {
    return coreAPIrequest({
      url: `/admin/mango-credit-transactions?${query.toString()}`,
      method: "GET",
    });
  }

  return coreAPIrequest({
    url: `/admin/mango-credit-transactions/csv?${query.toString()}`,
    method: "GET",
  });
};

export const getLastMigrationStats = () => {
  return request({
    method: "GET",
    url: `api/v1/admin/refernearn/products/migrations/last`,
  });
};

export const getInvoices = (
  type,
  startDate,
  endDate,
  search,
  page,
  limit,
  csv = false,
  country
) => {
  const query = new URLSearchParams();

  if (startDate && endDate) {
    query.append("startDate", new Date(startDate).toISOString());
    query.append("endDate", new Date(endDate).toISOString());
  }

  if (search) query.append("search", search);
  if (page) query.append("page", page);
  if (limit) query.append("limit", limit);
  if (country) query.append("country", country);

  if (!csv) {
    return coreAPIrequest({
      url: `/admin/invoices/${type}?${query.toString()}`,
      method: "GET",
    });
  }

  return coreAPIrequest({
    url: `/admin/invoices/${type}/csv?${query.toString()}`,
    method: "GET",
  });
};

export const tagPartner = (values, userId) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/users/${userId}/tag-parent`,
    data: values,
  });
};

export const untagPartner = (userId) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/refernearn/users/${userId}/untag-parent`,
  });
};

export const getManagePlanForTierOrder = (tierOrderId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/tier-orders/${tierOrderId}/manage-plan`,
  });
};

export const getManagePlanRequestedUsers = () => {
  return request({
    method: "GET",
    url: `/api/v1/admin/creators/manage-plans/requested-users`,
  });
};

export const getManagePlanRequests = (filters) => {
  const params = new URLSearchParams();

  if (filters.limit) params.append("limit", filters.limit);
  if (filters.page) params.append("page", filters.page);
  if (filters.search) params.append("search", filters.search);
  if (filters.startDate) params.append("startDate", filters.startDate);
  if (filters.endDate) params.append("endDate", filters.endDate);
  if (filters.requestStatus)
    params.append("requestStatus", filters.requestStatus);
  if (filters.sortOrder) params.append("sortOrder", filters.sortOrder);
  if (filters.requestedBy) {
    if (typeof filters.requestedBy === "string") {
      params.append("requestedBy", filters.requestedBy);
    } else if (Array.isArray(filters.requestedBy)) {
      filters.requestedBy.forEach((item) => {
        params.append(
          "requestedBy",
          typeof item === "string" ? item : item.value
        );
      });
    }
  }

  return request({
    method: "GET",
    url: `/api/v1/admin/creators/manage-plans?${params.toString()}`,
  });
};
export const getManagePlanDetails = (planId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/creators/manage-plans/${planId}`,
  });
};

export const approveManagePlan = (id, type, data, approveOnFly = true) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/creators/manage-plans/${type}/${id}/approve`,
    data: { ...data, approveOnFly },
  });
};

export const rejectManagePlan = (id, type, data) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/creators/manage-plans/${type}/${id}/reject`,
    data,
  });
};

export const updateRazorpayPayoutContactStatus = (creatorId) => {
  return request({
    method: "GET",
    url: `/update-razorpay-payout-contact-status?creator=${creatorId}`,
  });
};

export const validateBulkAccountManager = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/creators/account-manager/bulk/validate`,
    data,
  });
};

export const uploadBulkAccountManager = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/creators/account-manager/bulk`,
    data,
  });
};

export const getAccountManagers = () => {
  return request({
    method: "GET",
    url: `/api/v1/admin/creators/account-managers`,
  });
};

export const getCoaches = (query, cancelToken) => {
  return request({
    method: "GET",
    url: `/api/v1/analytics/coaches?${query}`,
    ...(cancelToken && { cancelToken }),
  });
};

export const getCoachesAnalytics = (query, cancelToken) => {
  return request({
    method: "GET",
    url: `/api/v1/analytics/coaches/analytics?${query}`,
    ...(cancelToken && { cancelToken }),
  });
};

export const getCoachDetails = (creatorId) => {
  return request({
    method: "GET",
    url: `/api/v1/analytics/coaches/${creatorId}`,
  });
};

export const getCoachAnalytics = (creatorId, startDate, endDate) => {
  const query = new URLSearchParams();

  if (startDate) {
    query.append("startDate", startDate);
  }
  if (endDate) {
    query.append("endDate", endDate);
  }

  return request({
    method: "GET",
    url: `/api/v1/analytics/coaches/${creatorId}/analytics?${query.toString()}`,
  });
};

export const getCoachesCSV = (query) => {
  return request({
    method: "GET",
    url: `/api/v1/analytics/coaches/csv?${query}`,
    responseType: "blob",
  });
};

// Bulk Payout APIs
export const validateBulkPayouts = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/partners/payouts/bulk/validate`,
    data,
  });
};

export const createBulkPayouts = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/refernearn/partners/payouts/bulk`,
    data,
  });
};

// Mango Config APIs
export const fetchMangoConfig = () => {
  return request({
    method: "GET",
    url: `/api/v1/admin/sales/mangoconfigs`,
  });
};

export const updateMangoConfig = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales/mangoconfigs`,
    data,
  });
};

// Sales APIs
export const fetchSales = (
  page = 1,
  limit = 10,
  sortOrder = "desc",
  statuses = [],
  search = ""
) => {
  const statusQuery = statuses.map((s) => `status=${s}`).join("&");
  let url = `/api/v1/admin/sales?limit=${limit}&page=${page}&sortOrder=${sortOrder}`;

  if (statusQuery) {
    url = `${url}&${statusQuery}`;
  }
  if (search) {
    url = `${url}&search=${encodeURIComponent(search)}`;
  }

  return request({
    method: "GET",
    url,
  });
};

export const fetchSaleById = (saleId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/sales/${saleId}`,
  });
};

export const createSale = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales`,
    data,
  });
};

export const updateSale = (saleId, data) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/sales/${saleId}`,
    data,
  });
};

export const cloneSale = (saleId) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales/clone`,
    data: { saleId },
  });
};

export const calculatePricingAndLink = (query) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/sales/mangoconfigs/plan-change?${query}`,
  });
};

export const fetchFeatureMangoConfig = (features = []) => {
  const query = features
    .map((f) => `features=${encodeURIComponent(f)}`)
    .join("&");
  return request({
    method: "GET",
    url: `/api/v1/admin/sales/mangoconfigs/features?${query}`,
  });
};

export const createSaleItem = (saleId, data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales/${saleId}/sale-items`,
    data,
  });
};

export const fetchSaleItems = (saleId) => {
  return request({
    method: "GET",
    url: `/api/v1/admin/sales/${saleId}/sale-items`,
  });
};

export const updateSaleItem = (saleId, saleItemId, data) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/sales/${saleId}/sale-items/${saleItemId}`,
    data,
  });
};

export const reorderSaleItems = (saleId, saleItems) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/sales/${saleId}/sale-items/reorder`,
    data: { saleItems },
  });
};

export const lookupCreator = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/creators/lookup`,
    data,
  });
};

export const createOneToOneItem = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales/one_to_one_items`,
    data,
  });
};

export const updateOneToOneItem = (itemId, data) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/sales/one_to_one_items/${itemId}`,
    data,
  });
};

export const fetchOneToOneItems = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/one_to_one_items?${searchParams.toString()}`,
  });
};

export const fetchPlanChangeTransactions = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/transactions/plan_change?${searchParams.toString()}`,
  });
};

export const fetchPriceBlockTransactions = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/transactions/price_block?${searchParams.toString()}`,
  });
};

export const exportPlanChangeTransactionsCsv = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/transactions/plan_change/csv?${searchParams.toString()}`,
    responseType: "blob",
  });
};

export const exportPriceBlockTransactionsCsv = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/transactions/price_block/csv?${searchParams.toString()}`,
    responseType: "blob",
  });
};

// Manual Payments APIs
export const fetchManualPayments = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v));
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return request({
    method: "GET",
    url: `/api/v1/admin/sales/manual_payments?${searchParams.toString()}`,
  });
};

export const createManualPayment = (data) => {
  return request({
    method: "POST",
    url: `/api/v1/admin/sales/manual_payments`,
    data,
  });
};

export const updateManualPayment = (id, data) => {
  return request({
    method: "PUT",
    url: `/api/v1/admin/sales/manual_payments/${id}`,
    data,
  });
};
